import { render, staticRenderFns } from "./WebSitePopUp.vue?vue&type=template&id=cdb0863c&scoped=true"
import script from "./WebSitePopUp.vue?vue&type=script&lang=js"
export * from "./WebSitePopUp.vue?vue&type=script&lang=js"
import style0 from "./WebSitePopUp.vue?vue&type=style&index=0&id=cdb0863c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb0863c",
  null
  
)

export default component.exports